function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o)
    return; if (typeof o === "string")
    return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor)
    n = o.constructor.name; if (n === "Map" || n === "Set")
    return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr))
    return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length)
    len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import { Icon } from '@nordlayer/rivendell-ui';
import { ORGANIZATIONS_NBI_LIST_PATH, PRODUCTS_LIST_PATH } from 'shared/constants/routes';
import { ACTIVITY_LIST_PATH } from 'routing/routes/activity/constants';
import { COUPONS_LIST_PATH } from 'routing/routes/coupons/constants';
import { PLANS_LIST_PATH } from 'routing/routes/customPlansManagement/constants';
import { DISTRIBUTORS_LIST_PATH } from 'routing/routes/distributors/constants';
import { MEMBERS_LIST_PATH } from 'routing/routes/members/constants';
import { ORGANIZATIONS_LIST_PATH } from 'routing/routes/organizations/constants';
import { PARTNERS_PATH } from 'routing/routes/partners/constants';
import { REFUNDS_LIST_PATH } from 'routing/routes/refunds/constants';
import { RESELLERS_LIST_PATH } from 'routing/routes/resellers/constants';
import { USERS_ROLES_LIST_PATH } from 'routing/routes/roles/constants';
import { SERVER_LIST_PATH } from 'routing/routes/servers/constants';
import { USERS_LIST_PATH, USERS_MANAGEMENT_PATH } from 'routing/routes/users/constants';
import { Features } from 'types/features/enums';
import { PermissionsEnum } from 'types/permissions/enums';
import { NAVIGATION_ITEM_TYPES } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
var redesignedUsersManagementItem = {
    label: 'Users management',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "administrators16"
    }),
    type: NAVIGATION_ITEM_TYPES.menu,
    permissions: [PermissionsEnum.ViewUsers],
    items: [{
            label: 'Users',
            href: USERS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewUsers],
            size: 'md'
        }, {
            label: 'Roles',
            href: USERS_ROLES_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewUsers],
            size: 'md'
        }]
};
var distributorsItem = {
    label: 'Distributors',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "distributors16"
    }),
    href: DISTRIBUTORS_LIST_PATH,
    type: NAVIGATION_ITEM_TYPES.link,
    size: 'md'
};
var oldUsersManagementItem = {
    label: 'User management',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "administrators16"
    }),
    href: USERS_MANAGEMENT_PATH,
    type: NAVIGATION_ITEM_TYPES.link,
    permissions: [PermissionsEnum.ViewUsers],
    size: 'md'
};
var organizationsItem = {
    label: 'Organizations',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "organizations16"
    }),
    href: ORGANIZATIONS_LIST_PATH,
    type: NAVIGATION_ITEM_TYPES.link,
    permissions: [PermissionsEnum.ViewOrganization],
    size: 'md'
};
var nbiOrganizationsItem = {
    label: 'NBI Organizations',
    prefix: /*#__PURE__*/ _jsx(Icon, {
        name: "organizations16"
    }),
    href: ORGANIZATIONS_NBI_LIST_PATH,
    type: NAVIGATION_ITEM_TYPES.link,
    permissions: [PermissionsEnum.ViewOrganization],
    size: 'md'
};
var cpOrganizationsItem = _objectSpread(_objectSpread({}, organizationsItem), {}, {
    label: 'CP Organizations'
});
export var getNavigationItems = function getNavigationItems(isUsersManagementEnabled, isDistributorsEnabled, isOrganizationsRedesignEnabled) {
    return [].concat(_toConsumableArray(isOrganizationsRedesignEnabled ? [nbiOrganizationsItem, cpOrganizationsItem] : [organizationsItem]), [{
            label: 'MSP Partners',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "msp_partners16"
            }),
            href: PARTNERS_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewPartner],
            size: 'md'
        }, {
            label: 'Resellers',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "resellers16"
            }),
            href: RESELLERS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ResellersManagement],
            size: 'md'
        }], _toConsumableArray(isDistributorsEnabled ? [distributorsItem] : []), [{
            label: 'Members',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "member16"
            }),
            href: MEMBERS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewMember],
            size: 'md'
        }, {
            label: 'Servers',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "servers16"
            }),
            href: SERVER_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewServer],
            size: 'md'
        }, {
            label: 'Refunds',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "refunds16"
            }),
            href: REFUNDS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewRefund],
            size: 'md'
        }, {
            label: 'Activity',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "activity16"
            }),
            href: ACTIVITY_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewActivityLog],
            size: 'md'
        }, {
            label: 'Custom plans',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "custom_plans16"
            }),
            href: PLANS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewDirectPlansAndPackages, PermissionsEnum.ViewPartnerPlansAndPackages],
            size: 'md'
        }, {
            label: 'Coupons',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "coupons16"
            }),
            href: COUPONS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            permissions: [PermissionsEnum.ViewCoupon],
            size: 'md'
        }], _toConsumableArray(isUsersManagementEnabled ? [redesignedUsersManagementItem] : [oldUsersManagementItem]), [{
            label: 'Products',
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "subscription16"
            }),
            href: PRODUCTS_LIST_PATH,
            type: NAVIGATION_ITEM_TYPES.link,
            allowedFeatureFlags: [Features.MultiProductProductsPage],
            permissions: [PermissionsEnum.ProductsManage],
            size: 'md'
        }]);
};
